import { Component, effect } from "@angular/core";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { COMMISSIONS } from "../../../../assets/i18n/commissions-translations";
import { environment } from "../../../../environments/environment";
import { GlobalVariables } from "../../../constants/global-constants";
import { DashboardService } from "../../../services/dashboard.service";
import { UtilitiesService } from "../../../services/utilities.service";
import * as QuickSightEmbedding from 'amazon-quicksight-embedding-sdk';
import { MatIconModule } from "@angular/material/icon";
import { MaintenanceBannerComponent } from "../maintenance-banner/maintenance-banner.component";


@Component({
  selector: 'app-partner-dashboard',
  standalone: true,
  imports: [
    MatProgressSpinner, MatIconModule, MaintenanceBannerComponent
  ],
  templateUrl: './partner-dashboard.component.html',
  styleUrl: './partner-dashboard.component.scss'
})
export class PartnerDashboardComponent {
  embeddedDashboardExperience: QuickSightEmbedding.DashboardExperience;
  embedUrl: string;
  dashboardId: string;
  themeArn: string;
  midnight: string = 'arn:aws:quicksight:us-east-1:245276500850:theme/8eb0c70f-50a0-4bf4-992a-bb77315dbe7e';
  classic: string = 'arn:aws:quicksight:us-east-1:245276500850:theme/94cfc1d7-b6a4-44e1-bfd4-161c6dd2cfe8';

  isLoading: boolean = true;
  isError: boolean = false;
  isDarkMode: boolean = false;
  clientId: number;
  language: string;
  translations: any;
  isDemo: boolean = false;
  role: string;
  isMaintenance: boolean = false;
  constructor(
    private dashboardService: DashboardService,
    private utilitiesService: UtilitiesService,
  ) {
    effect(() => {
      this.isDarkMode = this.utilitiesService.isDarkTheme();
      this.themeArn = this.isDarkMode ? this.midnight : this.classic;
      this.applyFilter();
    });
  }

  ngOnInit() {
    this.clientId = this.utilitiesService.clientId;
    this.role = this.utilitiesService.roleValue;
    this.isDarkMode = localStorage.getItem('theme') === GlobalVariables.darkTheme;
    this.language = localStorage.getItem('locale');
    this.themeArn = this.isDarkMode ? this.midnight : this.classic;
    this.translations = COMMISSIONS[this.language] || COMMISSIONS["en-us"];
    this.isDemo = this.utilitiesService.isDemoValue;
    this.getDashboardId()
    this.isMaintenance = environment.isMaintenance;
  }

  getDashboardId() {
    this.dashboardId = environment.dashboardPartnerId;
    this.getQuicksightEmbedURL(this.dashboardId);
  }

  getQuicksightEmbedURL(dashboardId: string) {
    this.dashboardService.getQuicksightEmbedURL(dashboardId).subscribe({
      next: (res: any) => {
        if (res) {
          this.embedUrl = res.EmbedUrl;
          this.embedVisual();
        }
      },
      error: (err: any) => {
        console.log(err);
      }
    })
  }

  //Quicksight Embedding
  async embedVisual() {
    const {
      createEmbeddingContext,
    } = QuickSightEmbedding;

    const embeddingContext = await createEmbeddingContext({
      onChange: (changeEvent, metadata) => {
        console.log('Context received a change', changeEvent, metadata);
      },
    });

    const frameOptions = {
      url: this.embedUrl,
      container: '#quicksight-dashboard-commissions',
      height: "100%",
      width: "100%",
    };
    const translationParams = Object.entries(this.translations).map(([key, value]) => ({
      Name: key,
      Values: [value]
    }));

    const contentOptions = {
      parameters: [
        {
          Name: 'partnerId',
          Values: [
            this.clientId
          ]
        },
        {
          Name: 'isDemo',
          Values: this.isDemo
        },
        ...translationParams
      ],
      locale: this.language,
      themeOptions: {
        themeArn: this.themeArn
      },
      onMessage: async (messageEvent) => {
        switch (messageEvent.eventName) {
          case 'CONTENT_LOADED': {
            this.isLoading = false;
            break;
          }
          case 'ERROR_OCCURRED': {
            this.isError = true;
            this.isLoading = false;
            break;
          }
        }
      },
    };

    //@ts-ignore
    this.embeddedDashboardExperience = await embeddingContext.embedDashboard(frameOptions, contentOptions);
  };

  applyFilter() {
    this.embeddedDashboardExperience?.setTheme(this.themeArn);
  }
}
